import { getCurrentDateTimeUKFormatted, isUkBankHoliday } from "./DateHelpers";

export const isWithinWorkingHours = (date?: Date) => {
  const now = new Date(getCurrentDateTimeUKFormatted());
  const day = now.getDay();
  const hour = now.getHours();

  if (isUkBankHoliday(now)) {
    return false;
  }

  //Working hours are 8 - 7pm Mon-Thurs and 8 - 5pm Fri
  if (day >= 1 && day <= 4) {
    return hour >= 8 && hour < 19;
  } else if (day === 5) {
    return hour >= 8 && hour < 17;
  }

  return false;
};
